import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TikTokIcon,
  YoutubeIcon,
} from '@/components/ui/icons/icons-new'
import { type PublishablePlatformType } from '@backend/lib/db/schema/platform'

const PLATFORM_META: Record<
  PublishablePlatformType,
  { label: string; Icon: typeof InstagramIcon; bg: string }
> = {
  instagram: { label: 'Instagram', Icon: InstagramIcon, bg: 'bg-pink-500' },
  linkedin: { label: 'LinkedIn', Icon: LinkedinIcon, bg: 'bg-blue-500' },
  tiktok: { label: 'TikTok', Icon: TikTokIcon, bg: 'bg-black' },
  youtube: { label: 'YouTube', Icon: YoutubeIcon, bg: 'bg-red-600' },
  facebook: { label: 'Facebook', Icon: FacebookIcon, bg: 'bg-[#1877F2]' },
}

/** Tiny header used to group breakdown rows by platform when a multi-platform
 *  scope is active. Matches the same brand-color circular icon used in the
 *  platform filter so the visual language stays consistent across the page. */
export function PlatformGroupHeader({ platform }: { platform: PublishablePlatformType }) {
  const { label, Icon, bg } = PLATFORM_META[platform]
  return (
    <div className="mb-2 flex items-center gap-2">
      <span className={`flex h-4 w-4 items-center justify-center rounded-full ${bg}`} aria-hidden>
        <Icon width={10} height={10} color="#FFFFFF" />
      </span>
      <span className="text-muted-foreground text-xs font-medium">{label}</span>
    </div>
  )
}
